// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import {
  selectAccountBalances,
  selectHasGss,
  useLazySuppressionsQuery,
} from "@/store/apis/linkApi"
import { useSelector } from "react-redux"
import { useEffect, useMemo } from "react"
import { GSS_PRODUCT_ID } from "@/utils/helpers/mappings"

export function useGssSuppression() {
  const [query, { data, isUninitialized, isFetching }] =
    useLazySuppressionsQuery()

  const accounts = useSelector(selectAccountBalances)

  const hasGss = useSelector(selectHasGss)

  useEffect(() => {
    if (hasGss) {
      query(GSS_PRODUCT_ID, true)
    }
  }, [hasGss])

  if (!hasGss) {
    return {
      isFetching: false,
      hasSuppression: false,
      hasMultipleAccounts: accounts.length > 1,
    }
  }

  const hasSuppression = useMemo(() => data && data.length > 0, [data])

  return {
    isFetching: isUninitialized || isFetching,
    hasSuppression: hasSuppression ?? false,
    hasMultipleAccounts: accounts.length > 1,
  }
}
